module.exports = __webpack_public_path__ + "static/media/20210401_213954_238_IMG_0050.f8eb1be3.jpg";